import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import { eventTypeSchema } from '../../../schemas'

export default function New({ account, accounts, navigation, packages = [] }) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="New Event Type"
    >
      <BackLink href="/manage/event_types">Back to Event Types</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={eventTypeSchema}
          resource="event_type"
          endpoint="/manage/event_types"
          backLink="/manage/event_types"
          submitLabel="Create Event Type"
          defaultValues={{
            name: '',
            icon: '',
            tagline: '',
            description: '',
            active: true,
            image: null,
            package_ids: []
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
                placeholder="e.g. Wedding, Funerals & Wakes, Birthday Party"
              />

              <FormFieldController
                control={control}
                name="tagline"
                label="Tagline"
                errors={errors}
                placeholder="One line shown under the name"
              />

              <FormFieldController
                control={control}
                name="description"
                label="Description"
                type="textarea"
                rows={3}
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="icon"
                label="Icon"
                errors={errors}
                placeholder="e.g. 💍"
                hint="Optional. An emoji or icon key."
              />

              <FormFieldController
                control={control}
                name="image"
                label="Image"
                type="file"
                accept="image/*"
                hint="Optional. JPG, PNG or WebP recommended."
                errors={errors}
              />

              {packages.length > 0 && (
                <FormFieldController
                  control={control}
                  name="package_ids"
                  label="Packages"
                  type="checkboxGroup"
                  options={packages.map(p => ({ value: p.id, label: p.name }))}
                  hint="Packages available for this occasion"
                  errors={errors}
                />
              )}

              <FormFieldController
                control={control}
                name="active"
                label="Active"
                type="checkbox"
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
